import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import NavBar from "../components/NavBar";
import TravelIinsuranceDetails from "../components/TravelIinsuranceDetails";

const TravelIinsurance = () => {
  return (
    <>
      {/* Navigation Bar */}
      <NavBar />

      {/* Navigation Bar */}
      <Breadcrumb title={"Travel Insurance"} />

      {/* Service Details Area */}
      <TravelIinsuranceDetails />

      {/* Footer One */}
      <FooterOne />
    </>
  );
};

export default TravelIinsurance;
